module.exports = __webpack_public_path__ + "img/no.7a116ca5.gif";